/** Given name, then surname. Same order as Patron management. */
export function formatPersonName(
  firstName?: string | null,
  lastName?: string | null,
  fallback = ""
): string {
  const name = [firstName?.trim(), lastName?.trim()].filter(Boolean).join(" ");
  return name || fallback;
}
